import { Link } from "react-router-dom";
import { hotGossipItems } from "@/mocks/home";

export default function HotGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50">
            🍉 热点爆料 <span className="text-primary-400">🔥</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500">
            全网最新网红塌房黑料，一手掌握
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {hotGossipItems.map((item, index) => (
            <Link
              key={item.id}
              to={`/article/${item.articleId}`}
              className={`group relative rounded-xl overflow-hidden cursor-pointer transition-all duration-500 hover:scale-[1.02] ${
                item.featured && index === 0
                  ? "md:col-span-2 md:row-span-2"
                  : ""
              }`}
            >
              <div
                className={`w-full ${
                  item.featured && index === 0 ? "aspect-[16/10]" : "aspect-[3/4]"
                }`}
              >
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-5 md:p-6">
                <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-50 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden md:block">
                  {item.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}